import { render, staticRenderFns } from "./AXbanner.vue?vue&type=template&id=4096cff6&scoped=true&"
import script from "./AXbanner.vue?vue&type=script&lang=js&"
export * from "./AXbanner.vue?vue&type=script&lang=js&"
import style0 from "./AXbanner.vue?vue&type=style&index=0&id=4096cff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4096cff6",
  null
  
)

export default component.exports